import { SORT_BY_BEST_MATCH } from '@wix/communities-forum-client-commons';
import { getPostSorting, getStyle } from './app-settings-selectors';
import { get } from 'lodash';

export const getCategoryPageSorting = (state, style = getStyle(state)) => {
  return get(state, 'sorting.categoryPage', getPostSorting(style));
};

export const getSearchPageSorting = (state) => get(state, 'sorting.searchPage', SORT_BY_BEST_MATCH);
